import { render, staticRenderFns } from "./goodsSelect.vue?vue&type=template&id=70c64ccd&scoped=true&"
import script from "./goodsSelect.vue?vue&type=script&lang=js&"
export * from "./goodsSelect.vue?vue&type=script&lang=js&"
import style0 from "./goodsSelect.vue?vue&type=style&index=0&id=70c64ccd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c64ccd",
  null
  
)

export default component.exports